import { useRef } from "react"

export function useConstant(value) {
    const ref = useRef(value);
    return ref.current;
}